import { render, staticRenderFns } from "./DocsDetail.vue?vue&type=template&id=7d3fb37e&scoped=true&"
import script from "./DocsDetail.vue?vue&type=script&lang=js&"
export * from "./DocsDetail.vue?vue&type=script&lang=js&"
import style0 from "./DocsDetail.vue?vue&type=style&index=0&id=7d3fb37e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3fb37e",
  null
  
)

export default component.exports